import { StringUtils } from '@/common/utils/StringUtils';
import { MenuItem, Select } from '@mui/material';

export const LoggerLevelCellRenderer = ({ value, data, context }) => {
  if (!data) return null;

  const levels = context?.levels ?? [];
  const currentValue = value ?? '';

  const handleChange = (event) => {
    const nextValue = event.target.value === '' ? null : event.target.value;
    context?.onLevelChange?.(data.fullName, nextValue);
  };

  return (
    <Select
      value={currentValue}
      onChange={handleChange}
      size="small"
      variant="standard"
      fullWidth
      displayEmpty
    >
      <MenuItem value="">Inherit</MenuItem>
      {levels.map((level) => (
        <MenuItem key={level} value={level}>{StringUtils.toUpperCamel(level)}</MenuItem>
      ))}
    </Select>
  );
};
